import * as sonbp from "sonbp";
import * as ifbase from "../base";
import * as bpset from "../sonbpIf.setting";

// POSCAでは固定値となる
var access_token = "";

/**
 * sonbp初期化
 */
export function sonbpInit(ifdto: ifbase.ifDto, divId: string, uri_prefix: string, uri_prefix2: string, token: string): void {

	// [sonbp] APIへのURIプレフィックス付与
	sonbp.global.baseUrl = uri_prefix + "api/files/{file_key}/bp/";
	sonbp.global.baseUtilUrl = uri_prefix2 + "api/bp/";

	// 通知関数登録（エラー）
	ifdto.bpView.onError(function (e : sonbp.type.event) {

		if (e.code == "VIEW_START_EXCEPTION") {

			console.log("bpView.startでエラー発生がしました。");
			ifdto.callbackError(e);
			return;
		}
		else if (e.code == "INVALID_PARAMS") {

			console.error("[sonbpIf] view.onerror", e);
			ifdto.callbackError(e);
			return;
		}
		else if (e.code == "EXCEPTION") {

			//コールバック先あるなら念のため通知
			console.error("[sonbpIf] view.onerror", e);
			ifdto.callbackError(e);
			return;
		}

		//debug
		console.error(e);
		ifdto.callbackOnApiError(e);

	});

	//IEのchangeイベント不備対応
	var browser = sonbp.util.js.getBrowser();
	if (browser.name == "ie" || browser.name == "edge") {
		$("input[type='text']").each(function (i, elem) {
			console.debug(elem.id);
			var tempATTRIBUTE = "data-lastvalue";
			$(elem).focus(function () {
				$(this).attr(tempATTRIBUTE, $(this).val());
			});
			$(elem).keyup(function (e) {
				if (e.keyCode.toString() != '13') return;
				var tempPrevValue = $(this).attr(tempATTRIBUTE);
				if ($(this).val() != tempPrevValue) {
					$(this).attr(tempATTRIBUTE, $(this).val());
					$(this).change();
					//$(this).blur();
				}
			});
		});
	}

	// 設定の上書き
	if (bpset.bpSettingOverwrite) bpset.bpSettingOverwrite(ifdto);

	ifdto.token = token;
}

/**
 * sonbp起動
 */
export function sonbpStart(ifdto: ifbase.ifDto, callback: (IResult: ifbase.IResult) => void): void {

	//tokenはfile_keyに偽装してサーバへ渡す
	let file_key = ifdto.token;

	//indexeddb強制未使用
	sonbp.util.store.storeFactory.judgeMode = (): sonbp.type.promise => {
		return new sonbp.type.promise((s, f) => {
			sonbp.util.store.storeFactory.storeMode = sonbp.util.store.StoreMode.memory;
			return s();
		});
	};
	(<any>ifdto.bpView).adjustPlatform = (): void => {
		//nop.
	};

	// [sonbp] ビュークラスの開始処理
	ifdto.bpView.start(access_token, function (e: sonbp.type.event) {
		if (e.data == sonbp.constant.startStatus.FINISH_PROC) {
			// [sonbp] ビューへのドキュメントロード
			sonbp.tool.document.load(ifdto.bpView, file_key,
				function () {

					try {

						let area = ifbase.util.getLayer(ifdto, ifbase.constants.LTYPE_AREA);
						if (area === null) return;

						// AREA_IMGレイヤーを最前面へ移動（有効保証エリア外にも配置できるようにする #28480）
						let lastIdx = ifdto.bpView._om._doc.pages[0].layers.length - 1;
						if (area.idx < lastIdx) {

							let layers = ifdto.bpView._om._doc.pages[0].layers;
							let diff = lastIdx - area.idx;
							// １つずつインデックスを大きくする（※objectManager.ts / layerMove）
							for (var i = 0; i < diff; i++) {

								let idx = area.idx + i;
								layers.splice(idx, 2, layers[idx + 1], layers[idx]);
							}
						}

						//仕上がり区分を取得
						ifbase.util.getItems(area.layer.items, (item: sonbp.object.baseItem): boolean => {
							return item.info.vendor_property.ffpsc?.item_type == "AREA_IMG";
						}).some(item => {

							//if (item.info.vendor_property.ffpsc?.preview_hidden == 1) {
							//	//仕上がり区分＝銀塩の赤枠はプレビュー用に非表示にしているので表示を復活させる
							//	item.info.vendor_property.ffpsc.preview_hidden = undefined;
							//	item.graphic.fill_opacity = 1.0;
							//}
							if (item.graphic.fill_opacity == 1.0) {
								ifdto.areaType = item.info.vendor_property.ffpsc.area_type;
								return true; // break
							}
						});

					}
					catch (e) {

						ifdto.callbackError(e);
					};
				},
				function () {

					try {

						//レイヤーの編集モードを初期化
						for (let pIdx = 0; pIdx < ifdto.bpView._om._doc.pages.length; pIdx++) {
							for (let lIdx = 0; lIdx < ifdto.bpView._om._doc.pages[pIdx].layers.length; lIdx++) {
								ifdto.bpView._om._doc.pages[pIdx].layers[lIdx].info.edit_mode = 0b00000000000000000;
							}
						}

						ifdto.normalScale.normalScaleRate = ifdto.bpView._dm.scaleRate;
						ifdto.normalScale.normalDrawPoint = ifdto.bpView._dm.drawPoint;
						//console.debug("normalScale2", ifdto.bpView._dm.scaleRate, ifdto.bpView._dm.drawPoint);

						ifdto.cleareCollbackError();
						callback({ code: 0 });

					}
					catch (e) {

						ifdto.callbackError(e);
					};
				}
			).catch((e) => {

				ifdto.callbackError(e);
			});
		}
	});
}
